import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../css/home.css";
import logo from "../logok.jpeg"

const Home = () => {
  const event = { name: "Kreative", date: "2025-03-03T00:00:00" };

  const calculateTimeLeft = () => {
    const eventDate = new Date(event.date);
    const now = new Date();
  
    if (isNaN(eventDate)) {
      console.error("Invalid event date format");
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
  
    const difference = eventDate - now;
    let timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };
  
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / (1000 * 60)) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
  
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const numLines = 50;
    const circuitContainer = document.querySelector(".animated-bg");

    for (let i = 0; i < numLines; i++) {
      const circuitLine = document.createElement("div");
      circuitLine.classList.add("circuit-line");

      circuitLine.style.left = `${Math.random() * 100}vw`;
      circuitLine.style.top = `${Math.random() * 100}vh`;
      circuitLine.style.animationDuration = `${Math.random() * 4 + 2}s`;
      circuitLine.style.animationDelay = `${Math.random() * 2}s`;
      circuitLine.style.opacity = Math.random() * 0.7 + 0.3;
      circuitLine.style.transform = `rotate(${Math.random() * 360}deg)`;
      
      circuitContainer.appendChild(circuitLine);
    }
  }, []);

  return (
    <div className="home-container">
      <div className="animated-bg"></div>
      <img src={logo} className="logo"></img>
      <h1 className="event-title">Kreative ' 25</h1>
      <h2 className="event-subtitle">
      The Department of Computer Science organises a National Level Technical Symposium (in association with CYBERHEFT & CSI).
 
</h2>
      <h3 className="event-date">March 3, 2025</h3>



      <div className="countdown">
        {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s
      </div>
      <Link to="/events" className="know-more-btn">Know More</Link>
      <div>
      
      </div>
    </div>

  );
};

export default Home;